<template>
  <div>
    <v-autocomplete
      hide-details
      :items="items"
      item-text="name"
      item-value="id"
      multiple
      outlined
      :loading="loading"
    >
      <template v-slot:selection="{ item, index }">
        <span
          v-if="index === 0"
          class="grey--text caption"
        >
            <template v-if="pickedIds.length === 1">{{ pickedIds.length }} item</template>
            <template v-else>{{ pickedIds.length }} items</template>
        </span>
      </template>

      <template v-slot:item="{ item }">
        <v-list-item
          ripple
          :style="{'padding-left': (item.level ? 30 * item.level : 0) + 'px'}"
          @click="toggle(item.id)"
        >
          <v-list-item-action
          >
            <v-icon>{{ icon(item.id) }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>


    <v-flex xs12 sm12 md12 v-if="pickedItems.length > 0">
      <v-flex xs12>
        <v-card class="filter-selected my-0" color="#F8F8F8" outlined tile elevation="0">
          <template v-for="(item, index) in pickedItems">
            <v-chip
              close-icon="$close"
              close
              outlined
              label
              color="#202020"
              :key="index"
              class="mr-2 my-1"
              @click:close="unpick(index)"
            >
              <span class="body-2">{{ item.name }}</span>
            </v-chip>
          </template>
        </v-card>
      </v-flex>
    </v-flex>
  </div>
</template>

<script>
  export default {
    name: "MultiplePickerGroupInput",
    props: {
      value: { },
      items: { type: Array, default: [] },
      loading: { type: Boolean, default: false }
    },
    data() {
      return {
        pickedIds: []
      }
    },
    computed: {
      pickedItems() {
        const _this = this;
        return _this.items.filter((item) => {
          return _this.pickedIds.find((id) => item.id === id)
        });
      },
    },
    methods: {
      icon(item) {
        let find = false;
        if(Array.isArray(item)) {
          let filter = item.filter(itemId => {
            return this.pickedIds.find(id => {
              return id === itemId;
            })
          })
          if(filter.length === item.length) {
            find = true;
          }
        } else {
          find = this.pickedIds.find(id => {
            return id === item;
          })
        }
        if (find) {
          return 'fas fa-check-square';
        } else {
          return 'far fa-square';
        }
      },
      toggle (item) {
        const _this = this;
          if (Array.isArray(item)) {
            let itemByGroup = item.filter(id => {
              if(!_this.pickedIds.includes(id)) return id;
            });
            if(itemByGroup.length > 0) {
              _this.pickedIds = _this.pickedIds.concat(itemByGroup);
            } else {
              _this.pickedIds = _this.pickedIds.filter(id => !item.includes(id));
            }
          } else {
            if(_this.pickedIds.find(id => item === id)) {
              _this.pickedIds = _this.pickedIds.filter(id => item !== id);
            } else {
              _this.pickedIds.push(item);
            }
          }
          _this.$emit('input', _this.pickedIds);
      },
      unpick(index) {
        this.pickedIds.splice(index, 1);
        this.$emit('input', this.pickedIds);
      },
    },
    watch: {
      value: {
        immediate: true,
        handler(value) {
          if (!Array.isArray(value)) {
            return;
          }

          this.pickedIds = value;
        }
      },
    }
  }
</script>

<style scoped>

</style>
